module.exports = __webpack_public_path__ + "static/media/Formular-Black.573e2f95.otf";